import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import * as DateHelpers from './DateHelpers';
import Modal from 'react-bootstrap/Modal';
import authService from './api-authorization/AuthorizeService';

interface PublicHolidays {
    showAddPublicHoliday: boolean;
    addPublicHoliday: AddPublicHoliday;
    holidayTypes: GenericList[];
    holidayRules: PublicHolidayRules[];
    startYear: number;
    endYear: number;
    holidayDates: PublicHolidayDates[];
    holidayYears: number[];
    deleteHolidayId: number;
    deleteHolidayIndex: number;
    deleteHolidayName: string;
    showConfirmModal: boolean;
    loading: boolean;
    errors: any;
}

interface AddPublicHoliday {
    name: string;
    holidayTypeId: number;
    specificDate: string;
    day: number;
    month: number;
    week: number;
    subId: string;
}

interface GenericList {
    id: number;
    description: string;
}

interface PublicHolidayRules {
    id: number;
    type: number;
    name: string;
    day: number;
    month: number;
    year: number;
    week: number;
}

interface PublicHolidayDates {
    name: string;
    date: string;
    dateDisplay: string;
}

export class PublicHolidayData extends React.Component<RouteComponentProps<{}>, PublicHolidays> {
    constructor(props: any) {
        super(props);

        //holiday years
        var today = new Date();
        var years:number[] = [];
        for (var i = 0; i < 5; i++) {
            years.push(today.getFullYear() + i);
        }

        this.state = {
            showAddPublicHoliday: false,
            addPublicHoliday: {
                name: "",
                holidayTypeId: -1,
                specificDate: "",
                day: 0,
                month: 0,
                week: 0,
                subId: ""
            },
            holidayTypes: [],
            holidayRules: [],
            startYear: today.getFullYear(),
            endYear: today.getFullYear(),
            holidayDates: [],
            holidayYears: years,
            deleteHolidayId: 0,
            deleteHolidayIndex: 0,
            deleteHolidayName: "",
            showConfirmModal: false,
            loading: true,
            errors: {}
        }
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=CreateEditAdminLists&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                this.getPublicHolidays();
            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    getPublicHolidays = () => {
        this.getPublicHolidayData();
    }

    async getPublicHolidayData() {
        const token = await authService.getAccessToken();
        axios.get('api/Admin/GetPublicHolidayData', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ holidayTypes: res.data.holidayTypes, holidayRules: res.data.holidayRules, loading: false });
        })
    }

    showAddPublicHoliday = () => {
        this.setState({ showAddPublicHoliday: !this.state.showAddPublicHoliday });
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = errors;
        this.setState(change);
    }

    handleAddChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let change: any = {};
        change = this.state.addPublicHoliday;
        change[e.target.name] = e.target.value;
        change["errors"] = errors;
        this.setState(change);
    }

    handleAddTypeChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        var publicHoliday = this.state.addPublicHoliday;
        publicHoliday.holidayTypeId = e.target.value * 1;
        //because we have changed the type, we need to reset the rest of the data
        publicHoliday.day = 0;
        publicHoliday.month = 0;
        publicHoliday.week = 0;
        publicHoliday.specificDate = "";
        
        this.setState({ addPublicHoliday: publicHoliday, errors: errors });
    }

    validateAdd = () => {
        let formIsValid = true;
        let errors: any = {};

        let fields = this.state.addPublicHoliday;
        if (!fields.name) {
            errors["name"] = "Name is Required";
            formIsValid = false;
        }

        if (fields.holidayTypeId < 1) {
            errors["holidayTypeId"] = "Type is Required";
            formIsValid = false;
        } else {
            if (fields.holidayTypeId == 1 && !fields.specificDate) {
                errors["specificDate"] = "Specific Date is Required";
                formIsValid = false;
            } else if (fields.holidayTypeId == 1 && !DateHelpers.isValidDate(fields.specificDate)) {
                errors["specificDate"] = "Valid Specific Date is Required";
                formIsValid = false;
            }
            if (fields.holidayTypeId > 1 && fields.holidayTypeId < 5 && (fields.day < 1 || fields.day > 31)) {
                errors["day"] = "Day between 1 and 31 is Required";
                formIsValid = false;
            }
            if (fields.holidayTypeId == 5 && (fields.day < -2 || fields.day > 1)) {
                //Easter Day Rule
                errors["day"] = "Day between -2 and 1 is Required";
                formIsValid = false;
            }
            if (fields.holidayTypeId > 1 && fields.holidayTypeId < 5 && (fields.month < 1 || fields.month > 12 )) {
                errors["month"] = "Month between 1 and 12 is Required";
                formIsValid = false;
            }
            if (fields.holidayTypeId == 4 && (fields.week < 1 || fields.week > 5)) {
                errors["week"] = "Week between 1 and 5 is Required";
                formIsValid = false;
            }

        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    submitAdd = () => {
        if (this.validateAdd()) {
            this.savePublicHolidays();
        }
    }

    async savePublicHolidays() {
        const user = await authService.getUser();
        const token = await authService.getAccessToken();

        var publicHoliday = this.state.addPublicHoliday;
        publicHoliday.subId = user.sub;

        axios.post('api/Admin/SavePublicHoliday', publicHoliday, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Public Holiday Saved");
            //then need to clear holiday so can save a new one
            var holiday: AddPublicHoliday = {
                name: "",
                holidayTypeId: -1,
                specificDate: "",
                day: 0,
                month: 0,
                week: 0,
                subId: ""
            };

            this.setState({ addPublicHoliday: holiday, showAddPublicHoliday: false });
            this.getPublicHolidays();
        })
        .catch(error => {
            var errors = error.response.data as any[];
            errors.map(function (error: any) {
                toast.error(error);
            });
        });
    }

    showPublicHolidays = () => {
        this.showPublicHols();
    }

    async showPublicHols() {
        const token = await authService.getAccessToken();

        axios.get('api/Admin/GetPublicHolidays?startYear=' + this.state.startYear + '&endYear=' + this.state.endYear, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ holidayDates: res.data });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    deleteItem = (e: any, deleteHolidayId: number, deleteHolidayIndex: number, deleteHolidayName: string) => {
        e.preventDefault();
        this.setState({ deleteHolidayId: deleteHolidayId, deleteHolidayIndex: deleteHolidayIndex, deleteHolidayName: deleteHolidayName, showConfirmModal: true });
    }

    hideConfirmModal = () => {
        this.setState({ deleteHolidayId: 0, deleteHolidayIndex: 0, deleteHolidayName: "", showConfirmModal: false });
    }

    saveConfirmModal = () => {
        this.savePublicHols();
    }

    async savePublicHols() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var publicHoliday = {
            publicHolidayId: this.state.deleteHolidayId,
            subId: user.sub
        };

        axios.post('api/Admin/DeletePublicHoliday', publicHoliday, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Public Holiday Deleted Successfully");
            var holidayRules = this.state.holidayRules;
            holidayRules.splice(this.state.deleteHolidayIndex, 1);

            this.setState({ holidayRules: holidayRules, deleteHolidayId: 0, deleteHolidayIndex: 0, deleteHolidayName: "", showConfirmModal: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            <h1>Public Holidays</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let holidayTypes = this.state.holidayTypes;
        let addPublicHoliday = this.state.addPublicHoliday;
        let holidayRules = this.state.holidayRules;
        let holidayDates = this.state.holidayDates;
        let showHolidayDates = holidayDates.length > 0;
        let holidayYears = this.state.holidayYears;

        return (
            <div>
                <div className="static-modal">
                    <Modal size="sm" show={this.state.showConfirmModal} onHide={this.hideConfirmModal}>
                        <Modal.Header className="modal__header--colour">
                            <Modal.Title>Delete Holiday/Rule</Modal.Title>
                            <button type="button" className="close" onClick={this.hideConfirmModal}>&times;</button>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <p>Are you sure you want to delete {this.state.deleteHolidayName}?</p>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <button className="popup-button--no" onClick={this.hideConfirmModal}>No</button>
                            <button className="popup-button--yes" onClick={this.saveConfirmModal}>Yes</button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div className={this.state.showAddPublicHoliday ? "hidden" : ""}>
                    <button className="defaultbutton defaultbutton__large form-margin" onClick={this.showAddPublicHoliday} type="button">Add Public Holiday Rule</button>
                </div>
                <div className={this.state.showAddPublicHoliday ? "" : "hidden"}>
                    <label className="input-group" htmlFor="name">
                        <span className="label">Name</span>
                        <input className="input" type="text" id="name" name="name" value={addPublicHoliday.name} onChange={(e) => this.handleAddChange(e)}></input>
                    </label>
                    <span className="label errors textalignleft marginLeft10">{this.state.errors["name"]}</span>

                    <label className="input-group" htmlFor="holidayType">
                        <span className="label">Type </span>
                        <select className="select" id="holidayType" name="holidayTypeId" value={addPublicHoliday.holidayTypeId} onChange={(e) => this.handleAddTypeChange(e)}>
                            <option hidden defaultValue="-1"></option>
                            {holidayTypes.map(type =>
                                <option key={type.id} value={type.id}>{type.description}</option>
                            )};
                        </select>
                    </label>
                    <span className="label errors textalignleft marginLeft10">{this.state.errors["holidayTypeId"]}</span>

                    <div className={addPublicHoliday.holidayTypeId == 1 ? "" : "hidden"}>
                        <label className="input-group" htmlFor="specificDate">
                            <span className="label">Specific Date</span>
                            <input type='date' id="specificDate" name="specificDate" className='input' value={addPublicHoliday.specificDate} onChange={(e) => this.handleAddChange(e)}></input>
                        </label>
                        <span className="label errors textalignleft marginLeft10">{this.state.errors["specificDate"]}</span>
                    </div>
                    <div className={addPublicHoliday.holidayTypeId > 1 ? "" : "hidden"}>
                        <label className="input-group" htmlFor="day">
                            <span className="label">Day</span>
                            <input type='number' min="-2" max="31" id="day" name="day" className='input' value={addPublicHoliday.day} onChange={(e) => this.handleAddChange(e)}></input>
                        </label>
                        <span className="label errors textalignleft marginLeft10">{this.state.errors["day"]}</span>
                    </div>
                    <div className={addPublicHoliday.holidayTypeId > 1 && addPublicHoliday.holidayTypeId < 5 ? "" : "hidden"}>
                        <label className="input-group" htmlFor="month">
                            <span className="label">Month</span>
                            <input type='number' min="0" max="12" id="month" name="month" className='input' value={addPublicHoliday.month} onChange={(e) => this.handleAddChange(e)}></input>
                        </label>
                        <span className="label errors textalignleft marginLeft10">{this.state.errors["month"]}</span>
                    </div>
                    <div className={addPublicHoliday.holidayTypeId == 4 ? "" : "hidden"}>
                        <label className="input-group" htmlFor="week">
                            <span className="label">Week</span>
                            <input type='number' min="0" max="5" id="week" name="week" className='input' value={addPublicHoliday.week} onChange={(e) => this.handleAddChange(e)}></input>
                        </label>
                        <span className="label errors textalignleft marginLeft10">{this.state.errors["week"]}</span>
                    </div>
                    <div>
                        <button className="defaultbutton defaultbutton__small form-margin" onClick={this.submitAdd} type="button">Add</button>
                        <button className="defaultbutton defaultbutton__small form-margin" onClick={this.showAddPublicHoliday} type="button">Cancel</button>
                    </div>
                    <span>Specific Date: when there is no way of calculating the date, e.g. Grand Final Day</span><br></br>
                    <span>Same Day and Month: when the holiday always falls on the exact same day and month, e.g. Anzac Day</span><br></br>
                    <span>Nearest Weekday: when holiday is on a weekend but observed on the nearest weekday, e.g. Christmas Day</span><br></br>
                    <span>Specific Day and Week of Month: when the holiday is on x day in y week, e.g. Labour Day is 2nd Monday in March (Day = 1 for Mon, Month = 3 for March, Week = 2 for 2nd week)</span><br></br>
                    <span>Easter: calculates Easter Sunday, for Good Friday use Day = -2, Easter Sunday use Day = 0, Easter Monday use Day = 1</span>
                </div>
                <div>
                    <hr></hr>
                </div>
                <div>
                    <div className="job__noteGridSize overflowAuto">
                        <table className="table tableColours">
                            <thead>
                                <tr>
                                    <th className="hidden">Id</th>
                                    <th>Name</th>
                                    <th>Type</th>
                                    <th>Day</th>
                                    <th>Month</th>
                                    <th>Year</th>
                                    <th>Week</th>
                                    <th></th>
                                </tr>
                            </thead>
                            {holidayRules.map((holiday, index) =>
                                <tbody key={holiday.id}>
                                    <tr>
                                        <td className="hidden">{holiday.id}</td>
                                        <td>{holiday.name}</td>
                                        <td>{holiday.type}</td>
                                        <td>{holiday.day}</td>
                                        <td>{holiday.month}</td>
                                        <td>{holiday.year}</td>
                                        <td>{holiday.week}</td>
                                        <td>
                                            <div className="delete--tablecell">
                                                <a className="makeitred" href="#" onClick={(e) => this.deleteItem(e, holiday.id, index, holiday.name)}>
                                                    <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
                <div>
                    <span>View actual holiday dates between {' '}
                        <select className="select" id="startYear" name="startYear" value={this.state.startYear} onChange={(e) => this.handleChange(e)} >
                            {holidayYears.map(year =>
                                <option key={year} value={year}>{year}</option>
                            )};
                        </select>
                        {' '} and {' '}
                        <select className="select" id="endYear" name="endYear" value={this.state.endYear} onChange={(e) => this.handleChange(e)} >
                            {holidayYears.map(year =>
                                <option key={year} value={year}>{year}</option>
                            )};
                        </select>
                    </span>
                    <button className="defaultbutton defaultbutton__small form-margin" onClick={this.showPublicHolidays} type="button">GO</button>
                </div>
                <div className={showHolidayDates ? "" : "hidden"}>
                    <div className="job__noteGridSize overflowAuto">
                        <table className="table tableColours">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            {holidayDates.map((dates, index) =>
                                <tbody key={index}>
                                    <tr>
                                        <td>{dates.name}</td>
                                        <td>{dates.dateDisplay}</td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        );

    }

};